import { useDeleteFunctionsMutation } from 'store/services/helios/functionsService';
import type { ModalsType } from 'types';

import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { ActionModal } from 'components/mui/common/ActionModal';
import { Typography } from '@mui/material';
import { useCallback } from 'react';

import { toast } from 'react-toastify';

interface AddFunctionModalProps extends ModalsType {
  ids: string[];
}

export const DELETE_FUNCTIONS_MODAL_TRANSLATE_PATH = 'helios.functions.deleteFunctionsModal';

export const ConfirmDeleteFunctionsModal: React.FC<AddFunctionModalProps> = ({ open, onClose, ids }) => {
  const { t } = useTranslation();
  const [deleteFunctions, { isLoading }] = useDeleteFunctionsMutation();

  const handleSubmit = useCallback(async () => {
    try {
      const res = await deleteFunctions({ ids });

      if (!('error' in res)) {
        toast.success(t('helios.functions.toasts.success.delete'));
        onClose();
      } else {
        toast.error(t('helios.functions.toasts.errors.delete'));
      }
    } catch (error) {
      toast.error(t('helios.functions.toasts.errors.delete'));
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, [deleteFunctions, ids, onClose, t]);

  return (
    <ActionModal
      open={open}
      title={t(`${DELETE_FUNCTIONS_MODAL_TRANSLATE_PATH}.title`)}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={handleSubmit}
      isSubmitting={isLoading}
      cancelText={t(`${DELETE_FUNCTIONS_MODAL_TRANSLATE_PATH}.buttons.cancel`)}
      submitText={t(`${DELETE_FUNCTIONS_MODAL_TRANSLATE_PATH}.buttons.delete`)}
      submitIcon={{
        icon: <DeleteIcon color="inherit" />,
        position: 'start',
      }}>
      <Typography>{t(`${DELETE_FUNCTIONS_MODAL_TRANSLATE_PATH}.description`)}</Typography>
    </ActionModal>
  );
};
